var _path, _mask, _g, _rect, _mask2, _g2, _path2, _mask3, _g3, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgWebCloudPlans = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 50,
  height: 63,
  viewBox: "0 0 50 63",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M49 6.46154C50 2.89531 47.1091 0 43.5484 0H6.45161C2.89086 0 0 2.89531 0 6.46154V54.6538C0 58.2201 2.89086 61.1154 6.45161 61.1154H41.5484C47.1091 61.1154 49 58.2201 49 54.6538V6.46154Z",
  fill: "#E3E3E3"
})), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
  id: "svg-public/img/icons/WebCloudPlans.svg__mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 50,
  height: 62
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M50 6.46154C50 2.89531 47.1091 0 43.5484 0H6.45161C2.89086 0 0 2.89531 0 6.46154V54.6538C0 58.2201 2.89086 61.1154 6.45161 61.1154H43.5484C47.1091 61.1154 50 58.2201 50 54.6538V6.46154Z",
  fill: "white"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#svg-public/img/icons/WebCloudPlans.svg__mask0)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M39.7851 47.9231C39.7851 47.9231 45.4302 47.9855 45.4302 43.0769C45.4302 38.1683 45.4302 5.11539 45.4302 5.11539C45.4302 5.11539 45.3302 2.86102e-06 40.3227 2.86102e-06C35.3152 2.86102e-06 36.0216 -4.30769 36.0216 -4.30769H55.3765V58.6923H43.5485L39.7851 47.9231Z",
  fill: "#D0D0D7"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.6103 52.4828L50.0001 15.0828V54.5192H15.6103V52.4828Z"
}), /*#__PURE__*/React.createElement("mask", {
  id: "svg-public/img/icons/WebCloudPlans.svg__mask1",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 15,
  y: 15,
  width: 35,
  height: 40
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.6103 52.4828L50.0001 15.0828V54.5192H15.6103V52.4828Z",
  fill: "white"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#svg-public/img/icons/WebCloudPlans.svg__mask1)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M39.7851 47.3846C39.7851 47.3846 45.4302 47.4471 45.4302 42.5384C45.4302 37.6298 45.4302 6.73075 45.4302 6.73075C45.4302 6.73075 45.3302 1.61536 40.3227 1.61536C35.3152 1.61536 36.0216 -2.69233 36.0216 -2.69233H55.3765V58.1538H43.5485L39.7851 47.3846Z",
  fill: "currentColor"
})), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.2151 47.3846C10.2151 47.3846 4.56992 47.4471 4.56992 42.5385C4.56992 37.6299 4.56992 5.11539 4.56992 5.11539C4.56992 5.11539 4.66992 2.86102e-06 9.67744 2.86102e-06C14.685 2.86102e-06 13.9785 -4.30769 13.9785 -4.30769H-5.37632V58.1539H6.45164L10.2151 47.3846Z",
  fill: "#C9CBD1",
  fillOpacity: 0.364706
}))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 6.72039,
  y: 53.3077,
  width: 38.4409,
  height: 8.61538,
  fill: "#393941"
})), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
  id: "svg-public/img/icons/WebCloudPlans.svg__mask2",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 6,
  y: 53,
  width: 40,
  height: 9
}, /*#__PURE__*/React.createElement("rect", {
  x: 6.72039,
  y: 53.3077,
  width: 38.4409,
  height: 8.61538,
  fill: "white"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#svg-public/img/icons/WebCloudPlans.svg__mask2)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.72039 56.8077H45.6989V61.9231H38.9785V60.0385H13.4408V61.9231H6.72039V56.8077Z",
  fill: "#020204"
}))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M40.3227 56.8077C40.7679 56.8077 41.1292 57.1695 41.1292 57.6154V62.1923C41.1292 62.6382 40.7679 63 40.3227 63H21.2367C20.7915 63 20.4303 62.6382 20.4303 62.1923V57.6154C20.4303 57.1695 20.7915 56.8077 21.2367 56.8077H40.3227ZM17.2044 56.8077C17.6495 56.8077 18.0108 57.1695 18.0108 57.6154V62.1923C18.0108 62.6382 17.6495 63 17.2044 63H11.0216C10.5764 63 10.2151 62.6382 10.2151 62.1923V57.6154C10.2151 57.1695 10.5764 56.8077 11.0216 56.8077H17.2044Z",
  fill: "#A7690D"
})), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
  id: "svg-public/img/icons/WebCloudPlans.svg__mask3",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 10,
  y: 56,
  width: 32,
  height: 7
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M40.3227 56.8077C40.7679 56.8077 41.1292 57.1695 41.1292 57.6154V62.1923C41.1292 62.6382 40.7679 63 40.3227 63H21.2367C20.7915 63 20.4303 62.6382 20.4303 62.1923V57.6154C20.4303 57.1695 20.7915 56.8077 21.2367 56.8077H40.3227ZM17.2044 56.8077C17.6495 56.8077 18.0108 57.1695 18.0108 57.6154V62.1923C18.0108 62.6382 17.6495 63 17.2044 63H11.0216C10.5764 63 10.2151 62.6382 10.2151 62.1923V57.6154C10.2151 57.1695 10.5764 56.8077 11.0216 56.8077H17.2044Z",
  fill: "white"
}))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#svg-public/img/icons/WebCloudPlans.svg__mask3)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M40.3227 60.0385C40.7679 60.0385 41.1292 60.4003 41.1292 60.8462V65.4231C41.1292 65.8689 40.7679 66.2308 40.3227 66.2308H21.2367C20.7915 66.2308 20.4303 65.8689 20.4303 65.4231V60.8462C20.4303 60.4003 20.7915 60.0385 21.2367 60.0385H40.3227ZM17.2044 60.0385C17.6495 60.0385 18.0108 60.4003 18.0108 60.8462V65.4231C18.0108 65.8689 17.6495 66.2308 17.2044 66.2308H11.0216C10.5764 66.2308 10.2151 65.8689 10.2151 65.4231V60.8462C10.2151 60.4003 10.5764 60.0385 11.0216 60.0385H17.2044Z",
  fill: "#FFC744"
}))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.5592 58.1538H12.3657V61.9231H11.5592V58.1538ZM15.8604 58.1538H16.6668V61.9231H15.8604V58.1538ZM21.7743 58.1538H22.5808V61.9231H21.7743V58.1538ZM23.9248 58.1538H24.7313V61.9231H23.9248V58.1538ZM26.0753 58.1538H26.8818V61.9231H26.0753V58.1538ZM28.2258 58.1538H29.0323V61.9231H28.2258V58.1538ZM30.3765 58.1538H31.1829V61.9231H30.3765V58.1538ZM32.527 58.1538H33.3334V61.9231H32.527V58.1538ZM34.6775 58.1538H35.4839V61.9231H34.6775V58.1538ZM36.828 58.1538H37.6344V61.9231H36.828V58.1538ZM38.9786 58.1538H39.7851V61.9231H38.9786V58.1538ZM14.5162 58.1538V61.9231H13.7097V58.1538H14.5162Z",
  fill: "#752F02",
  fillOpacity: 0.215686
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.2044 61.3846C17.6495 61.3846 18.0108 61.7465 18.0108 62.1923C18.0108 62.6382 17.6495 63 17.2044 63H11.0216C10.5764 63 10.2151 62.6382 10.2151 62.1923C10.2151 61.7465 10.5764 61.3846 11.0216 61.3846H17.2044ZM40.3227 61.3846C40.7679 61.3846 41.1292 61.7465 41.1292 62.1923C41.1292 62.6382 40.7679 63 40.3227 63H21.2367C20.7915 63 20.4303 62.6382 20.4303 62.1923C20.4303 61.7465 20.7915 61.3846 21.2367 61.3846H40.3227Z",
  fill: "#F4B031"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.5592 61.3846H12.3657V63H11.5592V61.3846ZM15.8604 61.3846H16.6668V63H15.8604V61.3846ZM13.7097 61.3846H14.5162V63H13.7097V61.3846ZM21.7743 61.3846H22.5808V63H21.7743V61.3846ZM23.9248 61.3846H24.7313V63H23.9248V61.3846ZM26.0753 61.3846H26.8818V63H26.0753V61.3846ZM28.2258 61.3846H29.0323V63H28.2258V61.3846ZM30.3765 61.3846H31.1829V63H30.3765V61.3846ZM32.527 61.3846H33.3334V63H32.527V61.3846ZM34.6775 61.3846H35.4839V63H34.6775V61.3846ZM36.828 61.3846H37.6344V63H36.828V61.3846ZM39.7851 61.3846V63H38.9786V61.3846H39.7851Z",
  fill: "#A53F00",
  fillOpacity: 0.215686
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M33.199 60.0385C33.57 60.0385 33.8711 60.34 33.8711 60.7115C33.8711 61.0831 33.57 61.3846 33.199 61.3846H21.9087C21.5377 61.3846 21.2367 61.0831 21.2367 60.7115C21.2367 60.34 21.5377 60.0385 21.9087 60.0385H33.199ZM39.5162 60.0385C39.8872 60.0385 40.1882 60.34 40.1882 60.7115C40.1882 61.0831 39.8872 61.3846 39.5162 61.3846H38.5753C38.2044 61.3846 37.9033 61.0831 37.9033 60.7115C37.9033 60.34 38.2044 60.0385 38.5753 60.0385H39.5162ZM14.9195 60.0385C15.2904 60.0385 15.5915 60.34 15.5915 60.7115C15.5915 61.0831 15.2904 61.3846 14.9195 61.3846H11.4248C11.0539 61.3846 10.7528 61.0831 10.7528 60.7115C10.7528 60.34 11.0539 60.0385 11.4248 60.0385H14.9195Z",
  fill: "white",
  fillOpacity: 0.211765
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M43.5484 47.3846C47.1091 47.3846 50 50.2799 50 53.8462V56.5385C50 60.1047 47.1091 63 43.5484 63H42.7419V60.3077C42.7419 59.4163 42.0194 58.6923 41.129 58.6923H10.2151C9.32473 58.6923 8.60215 59.4163 8.60215 60.3077V63H6.45161C2.89086 63 0 60.1047 0 56.5385V53.8462C0 50.2799 2.89086 47.3846 6.45161 47.3846H43.5484Z",
  fill: "black"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.12369 56.5385C8.23717 56.5385 9.13982 55.6344 9.13982 54.5192C9.13982 53.404 8.23717 52.5 7.12369 52.5C6.01021 52.5 5.10756 53.404 5.10756 54.5192C5.10756 55.6344 6.01021 56.5385 7.12369 56.5385Z",
  fill: "#3FDE7E"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.06461 54.5192C8.06461 53.9991 7.6431 53.5769 7.12375 53.5769C6.60439 53.5769 6.18289 53.9991 6.18289 54.5192C6.18289 55.0394 6.60439 55.4615 7.12375 55.4615C7.6431 55.4615 8.06461 55.0394 8.06461 54.5192Z",
  fill: "#2F5F55",
  fillOpacity: 0.470588
})));
export { SvgWebCloudPlans as ReactComponent };